import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';

import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';

import Typeahead from '@common/components/typeahead/typeahead.component';
import AccessControl from '@common/components/accessControl/accessControl.component';

import { Row, Col } from 'react-bootstrap';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    this.state = {
      showLookup: false,
    };
    autoBind(this);
  }

  get buttonSize() {
    return this.props.TamanhoButons || 10 - (this.props.TamanhoSuggestion || 12);
  }

  onOpenLookup() {
    this.setState({ showLookup: true });
  }

  onCloseLookup() {
    this.setState({ showLookup: false });
  }

  onSelectLookup(onSelect) {
    return (dataItem) => {
      const { mapLookupItem } = this.props;
      const item = mapLookupItem ? mapLookupItem(dataItem) : dataItem;
      onSelect(item);
      this.onCloseLookup();
    };
  }

  onChange(field, form) {
    return (e) => {
      form.setFieldValue(this.props.name, e);
      this.dispatchChanges(e, form, field);
    };
  }

  onChildChanged(value, form) {
    const { editavel } = this.props;
    if (editavel) form.setFieldValue(this.props.name, value);
  }

  renderComponent() {
    const { props } = this;
    const {
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      Placeholder,
      itens,
      mapItem,
      parameters,
      name,
      labelKey,
      addItem,
    } = props;

    return (
      <Field {...props}>
        {({ value, hasError, onChange, onChangeAsync, onBlur, form }) => {
          return (
            <Row>
              <Col>
                <LabeledInput {...props}>
                  <Typeahead
                    name={name}
                    className={`${hasError ? 'form-invalid' : ''}`}
                    value={value || ''}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    labelKey={labelKey}
                    itens={itens}
                    onChange={onChange}
                    onBlur={onBlur}
                    parameters={parameters}
                    placeholder={Placeholder || Label}
                    mapItem={mapItem}
                    title={Tooltip || Label}
                    addItem={addItem}
                  />
                </LabeledInput>
              </Col>
            </Row>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  {(field.value || {}).Exibicao || field.value || ''}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{(field.value || {}).Exibicao || field.value || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
